import React, { FC } from 'react';
import { ProductCardProps } from '../../types';
import CardBodyTopTag from './card-body-top-tag';
import CardBodyProductName from './card-body-product-name';
import CardBodyPrice from './card-body-price';
import CountDownLabel from '../countDownLabel';
import Lightning from '../lightning';
import ShipsFrom from './card-body-mkpl-ships';
import checkProductCardShowMkplSection from '@/utils/mkpl/checkProductCardShowMkplSection';
import CardBodyPredictDeliveryDate from './card-body-predict-delivery-date';

const CardBodyVerticalLightningHome: FC<Partial<ProductCardProps>> = props => {
  const { showSoldBy = true, data, activityTagLimit = null } = props;
  return (
    <div data-role="mid-box" className="mt-1.5 mx-2.5">
      <CardBodyPrice {...props} showSpecialPrice className="mt-0" />

      <CardBodyProductName {...props} className="my-1.5" />

      <CardBodyTopTag {...props} />

      {data?.status === 'begoing' ? (
        <CountDownLabel
          status="begoing"
          start={props?.countDownTimeStamp}
          end={props?.data?.start_time}
          className="px-0"
        />
      ) : (
        <Lightning {...props} className="px-0" />
      )}

      {showSoldBy && checkProductCardShowMkplSection(data, activityTagLimit)?.showShipsFrom && (
        <ShipsFrom key="ShipsFrom" {...props} className="max-w-full my-100" />
      )}
      <CardBodyPredictDeliveryDate {...props} className="my-0.5" />
    </div>
  );
};
export default CardBodyVerticalLightningHome;
